import React from 'react';
import { Image } from 'components/Image/Image';
import cartIcon from 'images/icons/cart-icon-2.svg';
import styles from './AccessoriesNotFound.module.scss';
import { TextV2 } from 'components/TextV2/TextV2';
import { useTranslation } from 'react-i18next';

/**
 * AccessoriesNotFound component shows a message with an icon when there are no accessories available.
 *
 * @component
 *
 * @example
 * return (
 *   <AccessoriesNotFound />
 * )
 *
 * @returns {React.ElementType} Returns a message and an icon.
 */
export const AccessoriesNotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.notFoundContentWrapper}>
      <Image className={styles.cartImage} src={cartIcon} aria-hidden="true" />
      <div className={styles.copy}>
        <TextV2 value={t('build-your-own.not-found.accessories')} variant="body" />
      </div>
    </div>
  );
};
